import './App.css';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import Soap from './components/images/soap.webp';
import Face from './components/images/facecareIMG.webp';
import HairOil from "./components/images/hair-oil.webp";
import HairShampoo from "./components/images/shempoo2.webp";
import { fetchProducts } from "./redux/actions/productAction.js";

function App() {
  const [activeProductId, setActiveProductId] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const productState = useSelector((state) => state.products);
  const { loading, error, products = [] } = productState;

  const [productList, setProductList] = useState([]);
  const [currItemList, setCurrItemList] = useState([]);

  // Fetch products
  useEffect(() => {
    dispatch(fetchProducts());
  }, [dispatch]);

  // Set product list when products change
  useEffect(() => {
    if (products.length > 0) {
      setProductList(products);
      setCurrItemList(products);
      console.log("Loaded products:", products);
    }
  }, [products]);

  // Open & Close Modal
  const handleModalOpen = (id) => setActiveProductId(id);
  const handleModalClose = () => setActiveProductId(null);

  // Navigate to OrderPage
  const handleBuyNow = (productId) => navigate(`/order/${productId}`);

  // Filter products by type (soap, shampoo, oil, etc.)
  const handleCategoryClick = (type) => {
    const filteredItems = productList.filter(
      (product) => product.type.toLowerCase() === type.toLowerCase()
    );
    setCurrItemList(filteredItems);
  };

  // Add item to cart
  async function handleAddToCart(itemId) {
    const user = localStorage.getItem("userDetails");
    if (!user) return alert("Please log in to add products to cart.");
    const userId = JSON.parse(user)._id;

    try {
      const res = await fetch("https://swarna-herbal-backend.onrender.com/api/cart/addItem", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userId, itemId: String(itemId), quantity: 1 }),
      });

      const data = await res.json();
      console.log("aa card", data)
      if (res.ok) {
        alert("Item added to your cart");
      } else {
        alert("Failed to add item");
        console.error("Error:", data.message);
      }
    } catch (err) {
      console.error("Error adding to cart:", err);
    }
  }

  return (
    <div className="App">
      {/* Video Section */}
      <div className="video-section" style={{ padding: "40px 0", textAlign: "center" }}>
        <h2 style={{ marginBottom: "20px" }}>Watch Our Videos</h2>
        <div
          className="video-container"
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "20px",
            flexWrap: "wrap",
          }}
        >
          <div className="video-item" style={{ width: "100%", maxWidth: "45%", marginBottom: "20px" }}>
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/phfPauT0XiQ"
              title="Video 1"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              style={{ borderRadius: "10px" }}
            ></iframe>
            <p>Video 1</p>
          </div>

          <div className="video-item" style={{ width: "100%", maxWidth: "45%", marginBottom: "20px" }}>
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/G9HQweQRdEA"
              title="Video 2"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              style={{ borderRadius: "10px" }}
            ></iframe>
            <p>Video 2</p>
          </div>
        </div>
      </div>

      {/* Navigation Section */}
      <nav className="second-nav">
        <ul>
          <li onClick={() => handleCategoryClick('face')}>
            <img src={Face} alt="Face" className="circle-img" />
            <span>Face Care</span>
          </li>
          <li onClick={() => handleCategoryClick('soap')}>
            <img src={Soap} alt="Soap" className="circle-img" />
            <span>Soap</span>
          </li>
          <li onClick={() => handleCategoryClick('shampoo')}>
            <img src={HairShampoo} alt="Shampoo" className="circle-img" />
            <span>Shampoo</span>
          </li>
          <li onClick={() => handleCategoryClick('oil')}>
            <img src={HairOil} alt="Hair Oil" className="circle-img" />
            <span>Hair Oil</span>
          </li>
        </ul>
      </nav>

      {/* Product Cards */}
      <main>
        <div className="product-cards">
          {currItemList.length === 0 ? (
            <p>No products found for this category.</p>
          ) : (
            currItemList.map((product) => (
              <div key={product._id} className="product-card">
                <img
                  src={`https://swarna-herbal-backend.onrender.com/uploads/${product.image}`}
                  alt={product.name}
                  className="product-image"
                />

                <div style={{ margin: "5px auto 0" }} className="product-info">
                  <h4>{product.name}</h4>
                  <p className="product-price">Price - ₹{product.price}</p>
                  <p className="product-price">Offer Price - ₹{product.offerPrice}</p>

                  <p className="product-short-description">
                    {product.description.length > 150
                      ? `${product.description.slice(0, 150)}...`
                      : product.description}
                  </p>

                  {product.description.length > 150 && (
                    <button
                      className="read-more-btn"
                      onClick={() => handleModalOpen(product._id)}
                    >
                      Read More
                    </button>
                  )}

                  <button
                    style={{ background: "green" }}
                    className="product-btn"
                    onClick={() => handleAddToCart(product._id)}
                  >
                    Add To Cart
                  </button>
                  <button
                    className="product-btn"
                    onClick={() => handleBuyNow(product._id)}
                  >
                    Buy Now
                  </button>
                </div>
              </div>
            ))
          )}
        </div>
      </main>

      {/* ✅ Modal Popup */}
      {activeProductId && (
        <div className="modal-overlay" onClick={handleModalClose}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button
              className="close-modal-btn"
              style={{ background: "red", color: "white" }}
              onClick={handleModalClose}
            >
              ×
            </button>

            {productList
              .filter((product) => product._id === activeProductId)
              .map((product) => (
                <div key={product._id}>
                  <img
                    src={`https://swarna-herbal-backend.onrender.com/uploads/${product.image}`}
                    alt={product.name}
                    className="modal-image"
                  />
                  <h3>{product.name}</h3>
                  <p className="modal-price">Price - ₹{product.price}</p>
                  <p className="modal-price">Offer Price - ₹{product.offerPrice}</p>
                  <p className="modal-description">
                    {product.description || "No description available"}
                  </p>
                  <button
                    style={{ background: "green" }}
                    className="buy-now-btn"
                    onClick={() => handleAddToCart(product._id)}
                  >
                    Add To Cart
                  </button>
                  <button
                    className="product-btn"
                    onClick={() => handleBuyNow(product._id)}
                  >
                    Buy Now
                  </button>
                </div>
              ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
